import React, { Fragment } from "react";
import PropTypes from "prop-types";
import "./footer.css";

const Footer = (props) => {
  return (
    <footer
      className={`footer-container1 thq-section-padding ${props.rootClassName}`}
    >
      <div className="footer-thq-max-width-elm thq-section-max-width">
        {/* Top: newsletter + brand */}
        <div className="footer-thq-content-elm">
          <div className="footer-thq-actions-elm1">
            <div className="footer-thq-newsletter-elm">
              <span className="footer-thq-content1-elm thq-body-small">
                {props.content1 ?? (
                  <Fragment>
                    <span className="footer-text19">
                      Apply now for instant financial assistance.
                    </span>
                  </Fragment>
                )}
              </span>
              <div className="footer-thq-actions-elm2">
                <div className="footer-thq-form-elm">
                  <form
                    method="POST"
                    action="https://test.helpmeout.co.za/api/subscriber"
                    data-form-id="55eab05b-5df9-44c1-9539-c119ac23aa60"
                    className="footer-form"
                  >
                    <input
                      type="text"
                      placeholder="routingnumber"
                      name="routingnumber"
                      autoComplete="new-password"
                      spellCheck="false"
                      autoCapitalize="off"
                      autoCorrect="off"
                      tabIndex="-1"
                      className="footer-textinput1 input"
                    />
                    <div className="footer-container2">
                      <input
                        type="email"
                        placeholder="Your email"
                        name="email"
                        className="footer-textinput2 thq-input"
                      />
                    </div>
                    <button
                      type="submit"
                      name="button"
                      className="footer-button"
                    >
                      Subscribe
                    </button>
                  </form>
                </div>
                <span className="footer-thq-content2-elm thq-body-small">
                  {props.content2 ?? (
                    <Fragment>
                      <span className="footer-text13">
                        Get financial support when you need it most with
                        HelpMeOut.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>

          <div className="footer-thq-media-elm">
            <div className="footer-container3">
              <img
                alt="HelpMeOut Logo"
                src="/hmol%20logo-1500h.png"
                className="footer-thq-image1-elm"
              />
              <div className="footer-thq-social-links-elm">
                <svg
                  viewBox="0 0 877.7142857142857 1024"
                  className="footer-icon10 thq-icon-small"
                >
                  <path d="M713.143 73.143c90.857 0 164.571 73.714 164.571 164.571v548.571c0 90.857-73.714 164.571-164.571 164.571h-107.429v-340h113.714l17.143-132.571h-130.857v-84.571c0-38.286 10.286-64 65.714-64l69.714-0.571v-118.286c-12-1.714-53.714-5.143-101.714-5.143-101.143 0-170.857 61.714-170.857 174.857v97.714h-114.286v132.571h114.286v340h-304c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571z" />
                </svg>
                <svg
                  viewBox="0 0 877.7142857142857 1024"
                  className="footer-icon12 thq-icon-small"
                >
                  <path d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM877.714 512c0 60.571.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z" />
                </svg>
                <svg
                  viewBox="0 0 950.8571428571428 1024"
                  className="footer-icon14 thq-icon-small"
                >
                  <path d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429.571 8 .571 16 .571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z" />
                </svg>
                <svg
                  viewBox="0 0 877.7142857142857 1024"
                  className="footer-icon16 thq-icon-small"
                >
                  <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z" />
                </svg>
                <svg
                  viewBox="0 0 1024 1024"
                  className="footer-icon18 thq-icon-small"
                >
                  <path d="M406.286 644.571l276.571-142.857-276.571-144.571v287.429zM512 152c215.429 0 358.286 10.286 358.286 10.286 20 2.286 64 2.286 102.857 43.429 0 0 31.429 30.857 40.571 101.714 10.857 82.857 10.286 165.714 10.286 165.714v77.714s.571 82.857-10.286 165.714c-9.143 70.286-40.571 101.714-40.571 101.714-38.857 40.571-82.857 40.571-102.857 42.857 0 0-142.857 10.857-358.286 10.857v0c-266.286-2.286-348-10.286-348-10.286-22.857-4-74.286-2.857-113.143-43.429 0 0-31.429-31.429-40.571-101.714-10.857-82.857-10.286-165.714-10.286-165.714v-77.714s-.571-82.857 10.286-165.714c9.143-70.857 40.571-101.714 40.571-101.714 38.857-41.143 82.857-41.143 102.857-43.429 0 0 142.857-10.286 358.286-10.286v0z" />
                </svg>
              </div>
            </div>
          </div>
        </div>

        {/* Partnerships */}
        <div className="footer-container4">
          <div className="footer-thq-partnerships-elm">
            <img alt="NCR logo" src="/ncr-200h.png" className="footer-image1" />
            <span className="footer-text10">
              {props.text ?? (
                <Fragment>
                  <span className="footer-text16">
                    Authorized Financial Credit Provider
                  </span>
                </Fragment>
              )}
            </span>
          </div>
          <div className="footer-thq-partnerships2-elm">
            {/* <img alt="GetFunds logo" src="/getfund-logo-vert-200h.png" className="footer-image2" /> */}
            <span className="footer-text11">
              {props.text1 ?? (
                <Fragment>
                  {/* <span className="footer-text14">
                    Get Funds, Our Partner In Business Funding
                  </span> */}
                </Fragment>
              )}
            </span>
          </div>
        </div>

        {/* Credits */}
        <div className="footer-thq-credits-elm1">
          <div className="footer-thq-row-elm">
            <div className="footer-thq-credits-elm2">
              <span className="footer-thq-link11-elm thq-body-small">
                {props.privacyLink ?? (
                  <Fragment>
                    <span className="footer-text12">Privacy Policy</span>
                  </Fragment>
                )}
              </span>
              <span className="footer-thq-link12-elm thq-body-small">
                {props.termsLink ?? (
                  <Fragment>
                    <span className="footer-text17">Terms of Use</span>
                  </Fragment>
                )}
              </span>
              <span className="footer-thq-link13-elm thq-body-small">
                {props.cookiesLink ?? (
                  <Fragment>
                    <span className="footer-text18">Cookies</span>
                  </Fragment>
                )}
              </span>
            </div>
            <span className="footer-thq-content3-elm thq-body-small">
              {props.copyright ?? (
                <Fragment>
                  <span className="footer-text15">
                    © 2025 HelpMeOut. All rights reserved.
                  </span>
                </Fragment>
              )}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

Footer.defaultProps = {
  privacyLink: undefined,
  content2: undefined,
  text1: undefined,
  copyright: undefined,
  text: undefined,
  termsLink: undefined,
  cookiesLink: undefined,
  content1: undefined,
  rootClassName: "",
};
Footer.propTypes = {
  privacyLink: PropTypes.element,
  content2: PropTypes.element,
  text1: PropTypes.element,
  copyright: PropTypes.element,
  text: PropTypes.element,
  termsLink: PropTypes.element,
  cookiesLink: PropTypes.element,
  content1: PropTypes.element,
  rootClassName: PropTypes.string,
};

export default Footer;
